export default __webpack_public_path__ + "static/media/ico-phone-24.23647045.svg";